import { render, staticRenderFns } from "./saveButton.vue?vue&type=template&id=6aa311a1&scoped=true&"
import script from "./saveButton.vue?vue&type=script&lang=js&"
export * from "./saveButton.vue?vue&type=script&lang=js&"
import style0 from "./saveButton.vue?vue&type=style&index=0&id=6aa311a1&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa311a1",
  null
  
)

export default component.exports